module.exports = __webpack_public_path__ + "static/img/10.116e98c2.png";